import { DateTime, HStack, Text } from "@project/ui";
import type { PageArticleFieldsFragment } from "./__generated/page-article.contentful.generated";

type ArticleTopicDateComponentProps = PageArticleFieldsFragment;

export const ArticleTopicDateComponent = (props: ArticleTopicDateComponentProps) => {
    const { topic, customFirstPublishedDate } = props;

    return (
        <HStack align="baseline" spacing={1} mb={{ base: 4, l: 8 }}>
            {topic && (
                <Text size="caption" color="grey300">
                    {topic} |
                </Text>
            )}
            <DateTime size="caption" color="grey300">
                {customFirstPublishedDate}
            </DateTime>
        </HStack>
    );
};
